export default "__VITE_ASSET__DMGs7grC__"